import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignHistoryItem from "../user-campaigns-history-item/component"
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import ModalPassword from "../modal-password/component";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {demoRegister} from "../../services/demoRegister";
import LanguageButton from "../language-button/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class userProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            account: {},
            edit_profile: false,
            edit_password: false,
            edit_email: false,
            email_pref: null,
            modal: false,
            email: "",
            first_name: "",
            last_name: "",
            old_password: "",
            password: "",
            confirm_password: "",
            isLoading: true
        };
        this._setModal = this._setModal.bind(this);
    };

    componentWillMount() {
        this._updateData();
        this._updateUser();
    }

    _updateUser(){
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse
            });
        }
    }

    _updateData(){
        dataRegister.account(salesChannelRegister.get("market")).then((response) => {
            try{
                response.country = response.country.toUpperCase();
            }catch (e) {}
            this.setState({account: response, email_pref: response.email_pref, isLoading: false});
        }, (error) => {});
    }

    _changePassword(){
        if(this.state.edit_password && !this.state.isLoading){
            if(this.state.old_password !== "" && this.state.password !== "" && this.state.confirm_password !== "" && this.state.password === this.state.confirm_password){
                this.setState({isLoading: true});
                let data = {new_password: this.state.password, new_password_confirm: this.state.confirm_password, old_password: this.state.old_password};
                dataRegister.resetPasswordToken(salesChannelRegister.get("market"), data).then((response) => {
                    this.setState({isLoading: false, password: "", old_password: "", confirm_password: "", edit_password: false, modal: true});
                }, (error) => {
                    this.setState({isLoading: false});
                });
            }else{

            }
        }
    }

    _changeAccount(){
        if((this.state.edit_profile || this.state.edit_email) && !this.state.isLoading){
            this.setState({isLoading: true});
            let data = {
                name: this.state.account.name,
                surname: this.state.account.surname,
                email_pref: this.state.email_pref,
                phone: this.state.account.phone
            };
            dataRegister.editAccount(salesChannelRegister.get("market"), data).then((item) => {
                this.setState({isLoading: false, edit_profile: false, edit_email: false});
            }, (error) => {
                this.setState({isLoading: false});
            });
        }
    }

    _changeProfileImage(e){
        try {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                if (files[0]) {
                    //ONLY ACCEPT IMAGE LES THAN 3 MB AND JPEG
                    if(files[0].size < 3000000 && files[0].type === "image/jpeg"){
                        const formData = new FormData();
                        formData.append("logo", files[0]);
                        dataRegister.postProfileImage(salesChannelRegister.get("market"), formData).then((response) => {
                            if(response.link){
                                this.state.account.profile_image = response.link;
                                this.setState({account: this.state.account}, () => {
                                    let user = userRegister.get();
                                    user.profile_image = response.link;
                                    userRegister.set(user);
                                });
                            }
                        }, (error) => {
                            console.log(error);
                        });
                    }
                }
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _setEmailPref(key){
        if(this.state.edit_email && !this.state.isLoading){
            this.state.email_pref[key] = !this.state.email_pref[key];
            this.setState({email_pref: this.state.email_pref});
        }
    }

    _signOut(){
        userRegister.remove();
        tokenRegister.remove();
        demoRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
    }

    _setModal(){
        this.setState({modal: false});
    }

    _renderProfileImage() {
        return (
            <div className={Styles.imagesContainerItem}>
                <div onClick={() => {
                    if ((this.state.admin || this.state.inhouse) && this.state.uploaded_image) {
                        this._next()
                    }
                }} className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.account.profile_image &&
                        <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                    }
                    {
                        this.state.account.profile_image &&
                        <div style={{backgroundImage: "url(" + this.state.account.profile_image + ")"}}
                             className={Styles.imagesContainerItemInnerUploadImage}/>
                    }
                    {
                        this.state.account.profile_image &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    <input onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.account.profile_image &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                        <input onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg"
                               className={Styles.imagesContainerItemInnerUpload}/>
                    </div>
                }
            </div>
        )
    }

    _renderText(item) {
        return langRegister.get("user-profile", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.modal &&
                    <ModalPassword setModal={this._setModal}/>
                }
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        this.state.account && this.state.email_pref && !this.state.isLoading &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.contentInnerItem}>
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_24")}
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDivider}>
                                            {this._renderProfileImage()}
                                        </div>
                                    </div>
                                }
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_2")}
                                    </div>
                                    {
                                        !this.state.edit_profile &&
                                        <div onClick={() => this.setState({edit_profile: true})} className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_profile &&
                                        <div onClick={() => this._changeAccount()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_profile &&
                                        <div onClick={() => this.setState({edit_profile: true})} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_profile &&
                                        <div onClick={() => this._changeAccount()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img  className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_profile
                                                })
                                        } onChange={(event) => {this.state.account.name = event.target.value; this.setState({account: this.state.account})}} readOnly={!this.state.edit_profile} value={this.state.account.name} placeholder={this._renderText("item_10")}/>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_profile
                                                })
                                        } onChange={(event) => {this.state.account.surname = event.target.value; this.setState({account: this.state.account})}}  readOnly={!this.state.edit_profile} value={this.state.account.surname} placeholder={this._renderText("item_11")}/>
                                    </div>
                                </div>
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.billing_company} placeholder={this._renderText("item_17")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.street} placeholder={this._renderText("item_18")}/>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.zipcode} placeholder={this._renderText("item_19")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.city} placeholder={this._renderText("item_20")}/>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.country} placeholder={this._renderText("item_21")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } readOnly={true} value={this.state.account.website} placeholder={this._renderText("item_22")}/>
                                        </div>
                                    </div>
                                }
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: true
                                                })
                                        } readOnly={true} value={this.state.account.email} placeholder={this._renderText("item_12")}/>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_profile
                                                })
                                        } onChange={(event) => {this.state.account.phone = event.target.value; this.setState({account: this.state.account})}} readOnly={!this.state.edit_profile} value={this.state.account.phone} placeholder={this._renderText("item_23")}/>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_password &&
                                        <div onClick={() => this.setState({edit_password: true})} className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_password &&
                                        <div onClick={() => this._changePassword()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_password &&
                                        <div onClick={() => this.setState({edit_password: true})} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_password &&
                                        <div onClick={() => this._changePassword()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img  className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_password
                                                })
                                        } onChange={(event) => this.setState({old_password: event.target.value})} readOnly={!this.state.edit_password} value={this.state.old_password} type={"password"} placeholder={this._renderText("item_16")}/>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_password
                                                })
                                        } onChange={(event) => this.setState({password: event.target.value})} readOnly={!this.state.edit_password} value={this.state.password} type={"password"} placeholder={this._renderText("item_13")}/>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input className={
                                            cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.edit_password
                                                })
                                        } onChange={(event) => this.setState({confirm_password: event.target.value})} readOnly={!this.state.edit_password} value={this.state.confirm_password} type={"password"} placeholder={this._renderText("item_14")}/>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    {
                                        !this.state.edit_email &&
                                        <div onClick={() => this.setState({edit_email: true})} className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_email &&
                                        <div onClick={() => this._changeAccount()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_email &&
                                        <div onClick={() => this.setState({edit_email: true})} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_email &&
                                        <div onClick={() => this._changeAccount()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img  className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.reminders &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && this.state.edit_email &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("reminders")} className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_6")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.offers &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && this.state.edit_email &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("offers")} className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_7")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.news &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && this.state.edit_email &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("news")} className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_8")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.surveys &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && this.state.edit_email &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("surveys")} className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_9")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userProfile;


// WEBPACK FOOTER //
// ./src/components/user-profile/component.js